/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class Layout extends PageStringSection {
    button_revertIdentity_label: string = "Labels.lbl_RevertIdentity";
    progress_AriaLabel: string = "Labels.lbl_Loading";
    text_identityAssumed: string = "Messages.msg_IdentityAssumed";
}
